import type { WireConversionInputs } from "./types";

export const defaultWireConversionInputs: WireConversionInputs = {
  sourceDiameter: 1.2,
  sourceWireFeed: 12.8,
  targetDiameter: 1
};
